import { BONUSES_ENABLED } from '@network/models/bonus.model'
import AuthService from 'helpers/authService'

/**
 * Checks if bonuses are enabled for the business
 */
export const hasBusinessBonusesEnabled = () => {
  const businessEntity = AuthService.getBusinessEntity()
  if (!businessEntity) return false

  return businessEntity.enabled_bonuses && BONUSES_ENABLED
}

/**
 * Checks if pay_rate_update_restriction setting is enabled for the business
 */
export const hasBusinessPayRateUpdateRestriction = () => {
  const businessEntity = AuthService.getBusinessEntity()
  if (!businessEntity) return false

  return businessEntity.business_setting?.pay_rate_update_restriction ?? false
}
